module.exports = __webpack_public_path__ + "img/battery_darkmode.67d7bf73.png";